import React, { useRef } from 'react';
import styled from 'styled-components';
import { motion, MotionValue, useReducedMotion, useScroll, useTransform } from 'framer-motion';

const Paragraph = styled.p`
  max-width: 30ch;
  font-size: clamp(1.75rem, 3.6vw, 3rem);
  font-weight: 500;
  line-height: 1.18;
  letter-spacing: -0.03em;
  color: ${props => props.theme.colors.text};
  text-wrap: pretty;
`;

const Word: React.FC<{ progress: MotionValue<number>; range: [number, number]; children: string }> = ({ progress, range, children }) => {
  const opacity = useTransform(progress, range, [0.16, 1]);
  return <motion.span style={{ opacity }}>{children} </motion.span>;
};

// Each word lights up in reading order as the paragraph scrolls through the viewport.
const WordReveal: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start 0.85', 'end 0.5'] });
  const words = text.split(/\s+/);

  if (reduceMotion) {
    return (
      <Paragraph ref={ref} className={className}>
        {text}
      </Paragraph>
    );
  }

  return (
    <Paragraph ref={ref} className={className}>
      {words.map((word, index) => (
        <Word key={`${word}-${index}`} progress={scrollYProgress} range={[index / words.length, (index + 1) / words.length]}>
          {word}
        </Word>
      ))}
    </Paragraph>
  );
};

export default WordReveal;
